import React, { useEffect } from 'react';
import ArrearsReportsDataTable from './ArrearsReportDataTable';

const ArrearsReportIndex = ({ rrhh }) => {
  useEffect(() => window.scrollTo(0, 0), []);
  return <ArrearsReportsDataTable rrhh={rrhh} />;
};

export default ArrearsReportIndex;
